import { DropStatus } from "@anaconda/core/drop/types"
import { useMolecule } from "bunshi/react"
import { DropMoleculeReatom } from "../store/drop-store.reatom"

export function usePhaseStatus(phaseNumber: number) {
  const { phasesAtom, nowAtom, isDropOverSupplyAtom } =
    useMolecule(DropMoleculeReatom)

  const phases = phasesAtom()
  const now = nowAtom()
  const isDropOverSupply = isDropOverSupplyAtom()

  const phase = phases[phaseNumber]

  const isUpcoming =
    phase.startDate && now < new Date(phase.startDate).getTime()
  const isExpired = phase.endDate && now >= new Date(phase.endDate).getTime()
  const isMinting = !isUpcoming && !isExpired

  if (isDropOverSupply) return DropStatus.OverSupply
  if (isUpcoming) return DropStatus.Upcoming
  if (isExpired) return DropStatus.Ended
  if (isMinting) return DropStatus.Minting

  return DropStatus.Ended
}
